// src/components/common/Modal.js
export default function Modal({
  title,
  children,
  onClose,
  size = "md", // sm, md, lg, xl, 2xl, 4xl, full
  maxHeight = "max-h-[80vh] overflow-auto",
  overlayClassName = "z-50",
}) {
  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    "4xl": "max-w-4xl",
    full: "max-w-full h-full"
  };

  return (
    <div className={`fixed inset-0 flex items-center justify-center bg-black/50 ${overlayClassName}`}>
      <div className={`bg-white rounded-lg shadow-lg p-6 w-full ${sizeClasses[size]} ${maxHeight}`}>
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-xl"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        {children}
      </div>
    </div>
  );
}


/*

Usage:
<Modal title="Small modal" size="sm" onClose={...}>...</Modal>
<Modal title="Medium modal" size="md" onClose={...}>...</Modal>
<Modal title="Large modal" size="4xl" onClose={...}>...</Modal>
<Modal title="Full Screen modal" size="full" onClose={...}>...</Modal>
*/